import { isNumber } from 'utils/tsHelpers';
import { SelectValueType } from 'ui/selects';
import { BaseOption, OnSelectHandler } from 'ui/selectv2/types';

const convertBaseOptions = <TValue extends SelectValueType>(
  values: TValue[],
  options: BaseOption<string>[],
): BaseOption<TValue>[] => {
  const areNumberValues = values.length !== 0 && values.every(isNumber);
  return options.map(({ value, ...rest }) => {
    const convertedValue = (areNumberValues ? parseFloat(value) : value) as TValue;
    return {
      ...rest,
      value: convertedValue,
    };
  });
};

export const getSelectHandler = <TValue extends SelectValueType>(
  values: TValue[],
  setInputValues: (value: BaseOption<TValue>[]) => void,
  onSelectChange?: (value: BaseOption<TValue>[]) => void,
): OnSelectHandler => {
  return (options) => {
    const convertedOptions = convertBaseOptions(values, options);
    setInputValues(convertedOptions);
    if (onSelectChange) onSelectChange(convertedOptions);
  };
};
